import './Breadcrumbs.scss'
import { ReactComponent as LeftShevronArrowIcon } from '../../images/Shevron Arrows/Left Shevron-Arrow Icon.svg';
import { ReactComponent as RightShevronArrowIcon } from '../../images/Shevron Arrows/Right Shevron-Arrow Icon.svg';
import { Link } from 'react-router-dom';
import RouteInfo from '../../RouteInfo';
import Sticky from 'react-stickynode';
import { Translation } from 'react-i18next';

let stickyElementRef: HTMLDivElement;

type Props = {
    routeInfo: RouteInfo[],
    backTo: string,
    isMobile?: boolean
}

function getCrumbsElements(routeInfo: { name: any; path: any; }[]) {


    return routeInfo.map(({ name, path }, index) => {
        // decode element names
        name = decodeURIComponent(name);

        var key = (name || "").replace(".", "");
        var elements = [];



        if (index + 1 === routeInfo.length)
            elements.push(<div key={`crumb-${key}`}><Translation>{t => t(name)}</Translation></div>);
        else
            elements.push(
                <div className='crumb-link-container' key={`div-crumb-${key}`}>
                    <Link to={path} key={`crumb-${key}`}><Translation>{t => t(name)}</Translation></Link>
                </div>
            );

        // If it's not the last, add an arrow icon between them
        if (index + 1 < routeInfo.length)
            elements.push(<RightShevronArrowIcon key={`arrow-${key}`} />);

        return elements;
    });
}

function Breadcrumbs(props: Props) {
    const stickyTop = (
        document.getElementsByClassName('dw-main-menu')[0]?.clientHeight
    );

    return (
        <div className={`dw-breadcrumbs`} ref={(el) => stickyElementRef = el!}>
            <Sticky top={stickyTop} activeClass='is-pinned'>
                <div className={`dw-breadcrumbs-content ${props.isMobile && "mobile"}`}>
                    {!props.isMobile ?
                        <>
                            <div className="dw-card back-link">
                                <div>
                                    <Link to={props.backTo} className="link-primary-simple" key="back-link">
                                        <LeftShevronArrowIcon key="left-shevron-icon" />
                                        <span key="back-text">
                                            <Translation>
                                                {t => t("Back")}
                                            </Translation>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                            <div className="dw-card breadcrumbs">
                                {getCrumbsElements(props.routeInfo)}
                            </div>
                        </> :
                        <div className='dw-card single-line'>
                            <div className='back-link'>
                                <Link to={props.backTo} className="link-primary-simple" key="back-link">
                                    <LeftShevronArrowIcon key="left-shevron-icon" />
                                </Link>
                            </div>
                            {getCrumbsElements(props.routeInfo).at(-1)}
                        </div>}
                </div>
            </Sticky>
        </div>
    );
}
export default Breadcrumbs;